import { HssItem } from "./hss-item";

export class HssDutyPeriod {
  index: number;
  startTime = new HssItem("StartTime");
  endTime = new HssItem("EndTime");
  greaterTime = new HssItem("PayCreditGreaterTime");
  payCreditActual = new HssItem("PayCreditActualCredit");
  payCreditDh = new HssItem("PayCreditDpDeadhead");
  payCreditDisplayed = new HssItem(null);
  sched121OnDuty = new HssItem("Scheduled121OndutyOndutyMinutes");
  sched121OnDutyStartTime = new HssItem("Scheduled121OndutyStartTime");
  sched121OnDutyEndTime = new HssItem("Scheduled121OndutyEndTime");
  actualOnDuty = new HssItem(null);
  schedOdl = new HssItem(null);
  actualOdl = new HssItem(null);
  isAugmented = new HssItem("IndicatorsAugmentation");
  fdpDuration = new HssItem("IndicatorsFdpDuration");
  fdpStart = new HssItem("IndicatorsFdpStartTime");
  fdpStartAcclim = new HssItem("IndicatorsFdpStartTimeAcclim");
  fdpEnd = new HssItem("IndicatorsFdpEndTime");
  fdpEndAcclim = new HssItem("IndicatorsFdpEndTimeAcclim");
  acclimStation = new HssItem("IndicatorsCurrAcclimStn");
  reserveFdp? = {
    begin: new HssItem(null),
    end: new HssItem(null),
  };

  constructor(index: number) {
    this.index = index;
  }
}
